import { render } from "./AppImageModal.vue?vue&type=template&id=81b547c2&scoped=true&ts=true"
import script from "./AppImageModal.vue?vue&type=script&lang=ts"
export * from "./AppImageModal.vue?vue&type=script&lang=ts"

import "./AppImageModal.vue?vue&type=style&index=0&id=81b547c2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b547c2"]])

export default __exports__